import { FormControlLabel, Switch } from '@mui/material';
import { useUserContext } from 'common/contexts/UserContext';
import * as React from 'react';

interface Props {
  inputProps: React.InputHTMLAttributes<HTMLInputElement>;
  defaultChecked?: boolean;
}

/** Toggle for setting whether anyone can join */
export const Joinability: React.FC<Props> = (props) => {
  const { user } = useUserContext();
  const email = user?.email || '';
  const domain = email.substring(email.indexOf('@'));

  const label = (
    <h4>
      Let anyone with an <span className="font-bold">{domain}</span> email join this company.
    </h4>
  );

  // eslint-disable-next-line
  // @ts-ignore
  const control = <Switch defaultChecked={props.defaultChecked} {...props.inputProps} />;

  return (
    <div>
      <FormControlLabel control={control} label={label} />
    </div>
  );
};
